<div class="alert alert-warning"> 
  <i class="fa-icon fa fa-exclamation-triangle"></i> 
  {{ userNotAssociatedToMemberPcpMessage }}
</div>
<div class="pcp-only-icon">
  <i class="fa fa-user-md fa-5x" aria-hidden="true"></i>
  <div>
    <h4>For PCPs Only</h4>
  </div>
</div>